export default __webpack_public_path__ + "static/media/furniture12.8064db07.jpeg";